import { useEffect } from "react"

import { removeBypassKey, updateBypassKey } from "./storage"

/**
 * Hook that checks for the correct maintenance mode BYPASS_KEY URI parameter
 * and initializes or resets the store accordingly.
 */
export const useBypassKey = (bypassMaintenanceKey: string): void => {

  // sets a given bypass key or removes existing one from local state if undefined/null is given
  useEffect(() => {
    if (bypassMaintenanceKey) {
      updateBypassKey(bypassMaintenanceKey)
    } else {
      removeBypassKey()
    }
  }, [bypassMaintenanceKey])
}